import { IXandrBannerAdObject } from "@almamedia/amr-adtech-stack/lib/services/ads/adrequest";
import { createLogger } from "@almamedia/amr-adtech-stack/lib/utils";
import { wallpaperStyles } from "./custom-styles";

const logger = createLogger("talouselama-custom-needs");

function changeParadeId(reverse?: boolean): void {
  window.console.log("changeParadeId", reverse);

  try {
    if (reverse) {
      // If we have seen wallpaper on previous page change the element back to almad-parade-wallpaper
      // Kauppalehdestä, syytä katsoa tämä kuntoon ennen liveytystä / onko tälle edes tarvetta.
      if (document.querySelectorAll("[data-wp]").length > 0) {
        const wallpaperParadeElement = document.querySelectorAll(
          "[data-wp]"
        )[0];
        wallpaperParadeElement.id = "almad-parade-wallpaper";
        window.ALMA?.ad?.clear?.(["#almad-parade-wallpaper"]);
      }
    } else if (!document.getElementById("almad-parade-removed")) {
      // Change parade-1 elment id to be able to display parade-1 at the top of the page
      const paradeE = document.getElementById("almad-parade-1");
      if (paradeE) {
        paradeE.id = "almad-parade-removed";
      }

      const wallpaperE = document.getElementById("almad-parade-wallpaper");
      if (wallpaperE) {
        wallpaperE.id = "almad-parade-1";
      }
      const newParadeE = document.getElementById("almad-parade-1");
      if (newParadeE) {
        newParadeE.setAttribute("data-wp", "true");
      }

      window.ALMA?.ad?.clear?.(["#almad-parade-removed"]);
      const removedParadeE = document.getElementById("almad-parade-removed");
      if (removedParadeE) {
        removedParadeE.style.display = "none";
      }
    }
  } catch (e) {
    logger.logError("changeParadeId", e);
  }
}

function refreshAndSetKW(
  placements: string[],
  modifications: Record<string, unknown>
) {
  for (let x = 0; x < placements.length; x += 1) {
    window.apntag.modifyTag(placements[x], modifications);
  }
  window.apntag.refresh(placements);
}

declare global {
  interface Window {
    programmaticWallpaper?: boolean;
  }
}

function detectProgrammaticWallpaper(adObj: IXandrBannerAdObject): void {
  const targetAdObj: {
    buyerMemberId: number;
    height: number;
    width: number;
    adType: string;
  } = { ...adObj } as never;

  if (window.location.search.indexOf("programmatic_override") !== -1) {
    targetAdObj.buyerMemberId = 0;
  }

  // Programmatic wallpaper detection
  if (
    targetAdObj.buyerMemberId !== 6931 &&
    targetAdObj.height === 1150 &&
    targetAdObj.width === 1600 &&
    targetAdObj.adType === "banner"
  ) {
    logger.logInfo("Programmatic wallpaper on almad-parade-1", adObj);

    // Reload wallpaper
    const divIds = ["almad-wallpaper-1", "almad-skyscraper-1"];
    const modify = {
      forceCreativeId: 104801021,
    };
    refreshAndSetKW(divIds, modify);

    wallpaperStyles(true);
    window.programmaticWallpaper = true;
  } else if (
    targetAdObj.buyerMemberId === 6931 &&
    targetAdObj.height === 1150 &&
    targetAdObj.width === 1600 &&
    targetAdObj.adType === "banner"
  ) {
    logger.logInfo(
      "Wallpaper on almad-parade-1 from member 6931 - collapse ad placement - check lineitem setup",
      targetAdObj
    );
    window.parent.apntag.collapseAd("almad-parade-1");
  }
}

function programmaticWallpaper(): void {
  try {
    if (!document.getElementById("almad-parade-removed")) {
      // Change id of original almad-parade-1 and set display to none
      const paradeE = document.getElementById("almad-parade-1");
      if (paradeE) {
        paradeE.id = "almad-parade-removed";
      }
      window.ALMA.ad?.clear(["#almad-parade-removed"]);
      const removedParadeE = document.getElementById("almad-parade-removed");
      if (removedParadeE) {
        removedParadeE.style.height = "464px";
      }

      // Create (move) almad-parade-1 inside almad-wallpaper-1
      const newParade1 = document.createElement("div");
      newParade1.setAttribute("id", "almad-parade-1");
      const wallpaperE = document.getElementById("almad-wallpaper-1");
      if (wallpaperE) {
        wallpaperE.appendChild(newParade1);
      }
    }
  } catch (e) {
    logger.logError("programmaticWallpaper", e);
  }
}

// eslint-disable-next-line import/prefer-default-export
export { changeParadeId, detectProgrammaticWallpaper, programmaticWallpaper };
